import { Component, inject, Input } from '@angular/core';
import { Alert, AlertLevel } from '../../models/alert.model';
import { AlertService } from '../../services/local/alert-service';

@Component({
  selector: 'app-alert-popup',
  imports: [],
  templateUrl: './alert-popup.component.html',
  styleUrl: './alert-popup.component.scss'
})
export class AlertPopupComponent {
  public alertService = inject(AlertService);

  @Input()
  alert!: Alert;

  constructor() { }

  get isError() {
    return this.alert && this.alert.level === AlertLevel.ERROR;
  }

  get isSuccess() {
    return this.alert && this.alert.level === AlertLevel.SUCCESS;
  }

  get isInfo() {
    return this.alert && this.alert.level === AlertLevel.INFO;
  }

  get isWarning() {
    return this.alert && this.alert.level === AlertLevel.WARNING;
  }

}
